export const SET_GREEDY_INPUT = "greedy_input";

export const NEW_OUTPUT = "NEW_OUTPUT";
export const CLEAR_OUTPUT = "CLEAR_OUTPUT";

export const GREEDY_HAS_STARTED = "GREEDY_HAS_STARTED";
export const GREEDY_HAS_FINISHED = "GREEDY_HAS_FINISHED";
